// extracted by mini-css-extract-plugin
export default {"actionsDot":"Popovers_actionsDot__lTOlV","disabled":"Popovers_disabled__EIuvi","disabledIcon":"Popovers_disabledIcon__KYW56"};